// eslint-disable-next-line import/prefer-default-export
export enum FlashBagType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
}
